import {Component, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {NavbarService} from 'services/connectors/navbar.service';
import {Constants} from 'config/constants';

@Component({
    selector: 'tpc-calculator-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
    private onChangeCategorySub: Subscription;
    calculatorName: string;
    categoryName: string;
    isThankYouScreen: boolean;

    constructor(protected navbarService: NavbarService) {
        this.onChangeCategorySub = navbarService.changeCategory$.subscribe((data) => {
            this.categoryName = Constants.headerTitles[data.calculatorName][data.categoryName];
            this.calculatorName = data.calculatorName;
            this.isThankYouScreen = data.isThankYouScreen;
        });
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.onChangeCategorySub) {
            this.onChangeCategorySub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/header/header.component.ts